import getPathnameWithQueryLocationUtil from 'utils/location/get-pathname-with-query'
import { PRODUCT_QUERY_PARAMETER } from 'modules/product/constants'
import { CART_HASH_VALUE_ACTION } from 'modules/cart/constants'

/**
 * @param {Object} props
 * @param {number} props.productId
 * @param {number} props.variantId
 * @returns {string}
 */
export default function getQuickShopHrefProductUtil (props) {
  const {
    variantId,
    productId
  } = props

  const pathnameWithQuery = getPathnameWithQueryLocationUtil()
  return `${pathnameWithQuery}?${PRODUCT_QUERY_PARAMETER.PRODUCT_ID}=${productId}&${PRODUCT_QUERY_PARAMETER.VARIANT_ID}=${variantId}#${CART_HASH_VALUE_ACTION.OPEN_QUICK_SHOP_PRODUCT_SIDEBAR}`
}
